<template>
  <div>
    <div class="mt-3">
      <span class="mb-2" style="color: black; font-size: small">
        Android (기기별 상이)
      </span>
      <div class="pa-2" style="background-color: #eaeaea; border-radius: 15px;">
        <div style="display: flex">
          <img class="ml-2 mt-2" src="../assets/images/appicon_square.png" alt="" style="width: 30px; height: 30px;">
          <div class="mb-1" v-if="title && title !==''" style="width: 220px; display: block;">
            <div style="display: flex; justify-content: space-between;">
              <span style="display: inline-block; color: black; font-size: small; font-weight: bold; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" class="mr-2 ml-3">
                {{ title }}
              </span>
              <span style="color: black; font-size: x-small; display: inline-block; white-space: nowrap;">오후 8:27</span>
            </div>
            <div style="display: flex;">
              <div style="display: inline-block; color: black; font-size: small; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" class="mr-0 ml-3">
                {{ body }}
              </div>
            </div>
          </div>
          <div v-else>
            <span style="color: gray; font-size: small" class="mr-2 ml-2">(내용이 없습니다)</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <span class="mb-2" style="color: black; font-size: small">
        iOS
      </span>
      <div class="pa-2" style="background-color: #eaeaea; border-radius: 15px;">
        <div style="display: flex;">
          <img class="ml-1" src="../assets/images/appicon_full.png" alt="" style="width: 50px; height: 50px;">
          <div class="mb-1" v-if="title && title !==''" style="width: 210px; display: block">
            <div style="display: flex; justify-content: space-between;">
              <span style="display: inline-block; color: black; font-size: medium; font-weight: bold; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" class="mr-2 ml-2">
                {{ title }}
              </span>
              <span style="color: gray; font-size: small; display: inline-block; white-space: nowrap;">5 분전</span>
            </div>
            <div style="flex-wrap: wrap;">
              <span class="mr-3 ml-1" style="color: black; font-size: medium; white-space: pre-wrap;">
                {{ body }}
              </span>
            </div>
          </div>
          <div v-else>
            <span style="color: gray; font-size: small" class="mr-2 ml-2">(내용이 없습니다)</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'body']
}
</script>
